export default __webpack_public_path__ + "static/media/pets.7d0525ba.pdf";